import {MouseEventHandler} from 'react';

import styled from 'styled-components';
import {useSelector} from 'react-redux';

import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {flexCenterVertically, flexColumn} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {body16Bold, body14Normal} from '~/shared/theme/typography';
import {getLocalizationService} from '~/shared/services/localisationService';
import {selectCurrentRestaurant} from '~/shared/store/selectors';
import {TextWithPreBullet} from '~/shared/components/RestaurantInfoShared';
import NewDesignBackButton from '~/shared/components/BackButton';

import {PageHeaderPrimaryBar as PrimaryBar} from './styled.pageHeader';

const Row = styled.div`
  ${flexCenterVertically}
  margin-top: auto;
  margin-bottom: auto;
`;

const RestaurantLogo = styled(ImageWithAlt)`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border: 1px solid ${({theme}) => theme.colors.supportNeutral};
  ${flipOnLTR`
    margin-left: 15px;
  `};
`;

const RestaurantDetails = styled.div`
  ${flexColumn}
  flex: 1;
  overflow: hidden;
  width: 0;
`;

const RestaurantName = styled.h1`
  ${body16Bold}
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const RestaurantCuisines = styled.div`
  margin-top: -5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const CuisineTypes = styled(TextWithPreBullet)`
  ${body14Normal}
  font-family: TakeawaySans, sans-serif;

  &::before {
    color: ${({theme}) => theme.colors.charcoal80};
  }
`;

const MenuPageHeaderForMobileAndTablet = ({onBackClick}: {
  onBackClick: MouseEventHandler<HTMLElement> | undefined;
}) => {
  const {t} = getLocalizationService();
  const currentRestaurant = useSelector(selectCurrentRestaurant);

  const cuisineTypes = Object.values(currentRestaurant?.cuisineTypes || []);

  return (
    <>
      <NewDesignBackButton onClick={onBackClick} ariaLabel={t('back')} variant="small" />
      {currentRestaurant && (
      <PrimaryBar>
        <Row>
          <RestaurantLogo
            src={currentRestaurant.logoUrl}
            alt={currentRestaurant.name}
            title={currentRestaurant.name}
          />
          <RestaurantDetails>
            <RestaurantName>{currentRestaurant.name}</RestaurantName>
            <RestaurantCuisines>
              {cuisineTypes.join(', ')}
              {currentRestaurant.isKosher && (
                <CuisineTypes
                  preBullet={!!cuisineTypes.length}
                >
                  {t('tagKosher')}
                </CuisineTypes>
              )}
            </RestaurantCuisines>
          </RestaurantDetails>
        </Row>
      </PrimaryBar>
      )}
    </>
  );
};

export default MenuPageHeaderForMobileAndTablet;
